import { render } from "./FolderIcon.vue?vue&type=template&id=d363f20e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/FolderIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d363f20e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d363f20e', __exports__)) {
    api.reload('d363f20e', __exports__)
  }
  
  module.hot.accept("./FolderIcon.vue?vue&type=template&id=d363f20e", () => {
    api.rerender('d363f20e', render)
  })

}


export default __exports__